import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { branch, compose, renderComponent } from 'recompose';
import { t } from '../../../modules/infra/i18n';

import {
  LENGTH_OF_PERIOD_OPTIONS,
  PAYROLL_KIND_OPTIONS,
  PAYROLL_KINDS,
  getLengthOfPeriodOptions,
  getPayrollKindOptions,
} from '../settings/commission/constants';
import Switch from '../../common/checkboxSwitch';
import Tooltip from '../../common/tooltip';
import Select from '../../common/select';
import { DAYS_OF_WEEK_OPTIONS } from '../constants';
import { payrollKindShape } from '../settings/commission/shapes';
import PercentageInput from '../../common/percentageInput';
import CommissionSplitFees from './commissionSplitFees';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../modules/infra/feature-flags';

const CommissionSplit = ({ payrollKind, payrollEnabled }) => (
  <Fragment>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">
      {t('shops:commission_split.heading')}
    </div>
    <div className="c-wrapper-horizontal u-pb--">
      <div className="layout layout--auto">
        <div className="layout__item">
          <div className="o-flexbox o-flexbox--content-align-center">
            <Switch
              label={(
                <span>
                  {t('shops:commission_split.enabled_label')}
                  <Tooltip className="u-type--uppercase">
                    {t('shops:commission_split.enabled_tooltip')}
                  </Tooltip>
                </span>
              )}
              name="payrollEnabled"
            />
          </div>
        </div>
      </div>
      <div className="layout u-1/2 u-mt-">
        <div className="layout__item">
          <span className="c-label-new">
            {t('shops:commission_split.payout_mode_label')}
            <Tooltip>
              {t('shops:commission_split.payout_mode_tooltip')}
            </Tooltip>
          </span>
          <Select
            className="c-select"
            name="payrollKind"
            options={getPayrollKindOptions()}
          />
        </div>
      </div>
      <div
        display-if={payrollEnabled && payrollKind === PAYROLL_KINDS.dailyPayroll}
        className="layout u-1/2 u-mt-"
      >
        <div className="layout__item">
          <div className="c-label-new">{t('shops:commission_split.auto_tip_only_fee_label')}</div>
          <PercentageInput
            className="c-input"
            name="dailyPayrollTipFee"
            parse={value => Number(value)}
          />
        </div>
      </div>
      <div display-if={payrollEnabled && payrollKind === PAYROLL_KINDS.commissionSplits}>
        <div className="layout layout--auto u-mt-">
          <div className="layout__item u-mt-">
            <div className="c-label-new">{t('shops:commission_split.one_touch_payout_fee_label')}</div>
            <PercentageInput
              className="c-input"
              name="commissionSplitsPercentFee"
              parse={value => Number(value)}
            />
          </div>
        </div>
        <div className="layout layout--auto u-mt">
          <div className="layout__item">
            <Switch
              label={t('shops:commission_split.cash_to_barber_services_label')}
              name="commissionSplitsCashToBarbersServices"
            />
          </div>
        </div>
        <div className="layout layout--auto u-mt-">
          <div className="layout__item">
            <Switch
              label={t('shops:commission_split.cash_to_barber_products_label')}
              name="commissionSplitsCashToBarbersProducts"
            />
          </div>
        </div>
        <div className="layout layout--auto u-mt-">
          <div className="layout__item">
            <Switch
              label={t('shops:commission_split.shop_pays_fees_label')}
              name="commissionSplitsShopPaysFees"
            />
          </div>
        </div>
        <div className="layout u-mt">
          <div className="layout__item u-1/2">
            <span className="c-label-new">{t('shops:commission_split.end_of_pay_period_day_label')}</span>
            <Select
              className="c-select"
              name="commissionPayoutDayOfWeek"
              options={DAYS_OF_WEEK_OPTIONS}
              parse={val => parseInt(val, 10)}
              empty
            />
          </div>
          <div className="layout__item u-1/2">
            <span className="c-label-new">{t('shops:commission_split.length_of_period_label')}</span>
            <Select
              className="c-select"
              name="commissionPayoutPeriodInDays"
              options={getLengthOfPeriodOptions()}
              parse={val => parseInt(val, 10)}
              empty
            />
          </div>
        </div>
      </div>
    </div>
  </Fragment>
);

CommissionSplit.propTypes = {
  payrollKind: payrollKindShape.isRequired,
  payrollEnabled: PropTypes.bool.isRequired,
};

export default compose(
  withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE]),
  branch(
    props => props[flagNames.AUTOPAYOUT_SELF_SERVE],
    renderComponent(CommissionSplitFees),
    renderComponent(CommissionSplit),
  ),
)(null);
